
define('template!companiesDetailBodyView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="tabs-region"></div>\n<div class="body-container">\n  <div class="tabs-body">\n    <div class="info region"></div>\n    <div class="subaccounts region"></div>\n    <div class="orders region"></div>\n    <div class="offers region"></div>\n  </div>\n</div>\n';

}
return __p
};});

